import axios from "axios";
import { isRequestCanceled } from "../../Common/isRequestCanceled";
import { getSessionAuthHeader, withSessionFields } from "../../Common/sessionAuth";

export { isRequestCanceled };

/**
 * Standard Node API POST used across Quickvee admin (multipart body + Bearer token).
 * Supports AbortSignal for React Query request cancellation.
 */
export async function postNodeMultipart(url, data, signal) {
  const { token, ...body } = data;
  // A caller that left out the token or session fields still sends the signed-in session's.
  const response = await axios.post(url, withSessionFields(body), {
    headers: {
      "Content-Type": "multipart/form-data",
      ...(token ? { Authorization: `Bearer ${token}` } : getSessionAuthHeader()),
    },
    signal,
  });
  return response;
}

export function toApiError(error) {
  // Never wrap aborts — React Query must see the real cancel error or it
  // marks the query as failed and may retry a request that was intentionally stopped.
  if (isRequestCanceled(error)) {
    throw error;
  }
  return {
    message: error?.message || "Request failed",
    status: error?.response?.status ?? (error?.message === "Network Error" ? "Network Error" : undefined),
    isNetwork: error?.message === "Network Error",
    data: error?.response?.data ?? null,
  };
}
